import { useLayoutEffect as u } from "react";
import f from "../useRequestAnimationFrameState/useRequestAnimationFrameState.js";
const d = (e) => {
  const [n, t] = f();
  return u(() => {
    const r = e?.current;
    if (!r)
      return;
    const s = new ResizeObserver((i) => {
      i.forEach((o) => {
        const { clientWidth: c, clientHeight: a } = o.target;
        t({
          height: a,
          width: c
        });
      });
    });
    return s.observe(r), () => {
      s.disconnect();
    };
  }, [e, t]), n;
};
export {
  d as default
};
//# sourceMappingURL=useSize.js.map
